/* Sætter sprogets forkortelse (fx /en eller /pl) foran interne links på de oversatte sider.
   Baggrund: links der er skrevet ind i tekster og indstillinger som "/pages/donation" eller
   "https://tuttelu.dk/pages/donation" fører ellers den engelske besøgende over på den danske side.
   Gør ingenting på den danske side. Rører ikke ved links til Loop (/a/...), kassen, filer eller andre domæner.
   Rettes ved sideindlæsning, når indhold kommer til bagefter, og lige før et klik. */
(() => {
  const script = document.currentScript;
  const root = ((script && script.dataset.root) || '/').replace(/\/$/, ''); // "" på dansk, "/en" på engelsk
  if (!root) return;

  const HOSTS = [location.host, 'tuttelu.dk', 'www.tuttelu.dk'];
  const PATHS = /^\/(?:$|(?:pages|collections|products|blogs|policies|search|cart)(?:[/?#]|$))/;

  const fix = (a) => {
    if (!a || a.hasAttribute('data-no-lang')) return;
    const raw = a.getAttribute('href');
    if (!raw || raw.charAt(0) === '#' || raw.charAt(0) === '?') return;
    let path = raw;
    if (/^https?:\/\//i.test(raw)) {
      let url;
      try { url = new URL(raw); } catch (e) { return; }
      if (!HOSTS.includes(url.host)) return;
      path = url.pathname + url.search + url.hash;
    } else if (raw.charAt(0) !== '/' || raw.charAt(1) === '/') {
      return;
    }
    if (path === root || path.startsWith(root + '/') || path.startsWith(root + '?')) return;
    if (!PATHS.test(path)) return;
    a.setAttribute('href', root + path);
  };

  const fixAll = (scope) => (scope || document).querySelectorAll('a[href]').forEach(fix);
  const onEvent = (e) => fix(e.target && e.target.closest && e.target.closest('a[href]'));

  const start = () => {
    fixAll();
    let timer;
    new MutationObserver(() => { clearTimeout(timer); timer = setTimeout(fixAll, 200); })
      .observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  ['pointerdown', 'click', 'auxclick', 'focusin'].forEach((type) => document.addEventListener(type, onEvent, true));
})();
